module.exports = __webpack_public_path__ + "static/media/Godaddy.a450396a.svg";